export const headersTermoReferenciaOrgInter = [
  { text: '', width: 1, key: 'offCanvas' },
  { text: 'ID', width: 2, key: 'id' },
  { text: 'Status', width: 8, key: 'status' },
  { text: 'Nº Termo de Referência', width: 30, key: 'termoReferencia' },
  { text: 'Data TR', width: 10, key: 'dataTermoRef' },
  { text: 'Valor Total TR R$', width: 10, key: 'valorTransferido' },
  { text: 'Valor Total TR US$', width: 10, key: 'valorTotalDolares' },
];

export const valoresExibidosTermoReferenciaOrgInter: Record<string, string> = {
  id: 'ID',
  dataRegistro: 'Data de Registro',
  dataAtualizacao: 'Última Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  dataUltimaAtualizacao: 'Última Atualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  usuarioRegistro: 'Responsável pelo Registro',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',
  observacoes: 'Observações',

  // Fase
  dataContrato: 'Data Contrato',
  contratoCambio: 'Contrato de Câmbio',
  valorTransferido: 'Valor Transferido R$',
  cotacaoDolar: 'Cotação do Dólar',
  valorTotalDolares: 'Total em US$',
  valorTotal: 'Valor Total R$',
  termoReferencia: 'Nº Termo Ref.',
  dataTermoRef: 'Data Termo Ref.',
  status: 'Status',

  //Separadores
  separador: '',
  separadorLog: '',
  separadorValores: '',
};

export const fieldObjectTransferenciasOrgInter = [
  'usuarioRegistro.nomeCompleto',
  'usuarioAtualizacao.nomeCompleto',
  'usuarioUltimaVisualizacao.nomeCompleto',
  'responsavel.nomeCompleto',
  'proaq.id',
  'proaqResponsavel.responsavel',
  'produtoDAF.produtoFarmaceutico',
  'denominacaoGenerica.denominacaoGenerica',
  'KitProdutoDAF.nomeKit',
];
